import { HistoryRecoveryActionType } from 'my-constants/action-types'
import HistoryRecoveryService from 'my-services/history_recovery/HistoryRecoveryService'
import {get as _get} from "lodash";

export const getHistoryRecover = () => {
    return (dispatch) => {
        return HistoryRecoveryService.getHistory()
            .then(res => {
                if (res.status) {
                    dispatch({
                        type: HistoryRecoveryActionType.GET_HISTORY_RECOVERY_SUCCESS,
                        payload: _get(res, 'res.data.List', []),
                    });
                } else {
                    dispatch({
                        type: HistoryRecoveryActionType.GET_HISTORY_RECOVERY_FAIL,
                        payload: {
                            status: false,
                            error_description: _get(res, 'res.data.message', '')
                        },
                    });
                }
            }).catch(e => {
                dispatch({
                    type: HistoryRecoveryActionType.GET_HISTORY_RECOVERY_FAIL,
                    payload: _get(e, 'response.data', {
                        status: false,
                        error_description: e.stack,
                    }),
                });
            });
    }
};